'use client';

import styled from 'styled-components';
import { colors } from '@/styles';

export const FieldList = styled.div`
  font-family: monospace;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`;
